import React from 'react'
import styles from './AppointmentForm.module.scss'

type StepProps = React.PropsWithChildren<{
  name: string,
  title: string,
}>

/** One numbered row of the booking form */
export const Step: React.FC<StepProps> = ({ name, title, children }) => (
  <div className={styles.step} data-step={name}>
    <i className={styles.stepIcon} />
    <div className={styles.stepInfo}>
      <div className={styles.stepTitle}>
        {title}:
      </div>
      <div className={styles.stepContent}>
        {children}
      </div>
    </div>
  </div>
)
